export {
  TextWithIndicator as default,
  TextWithIndicator,
} from "@shared/src/components/ui/common/misc/TextWithIndicator";
